
import React, { useState, useEffect, useRef } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, TableRow, Table, TableHead, TableBody, TableCell, TableContainer, Paper, FormHelperText } from "@material-ui/core";
import { Box } from "@material-ui/core";
import LessonService from "./Locality/Service/lessonService";
import IconMasterService from "./Locality/Service/iconMasterService";
import AddClassService from "./Locality/Service/addClassService";
import SectionService from "./Locality/Service/sectionService";
import * as Yup from 'yup';
import TablePagination from '@material-ui/core/TablePagination';
import { Grid, Select, TextField } from "@material-ui/core";
import { useFormik } from 'formik';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Typography } from "@material-ui/core";
import Widget from "../../components/Widget/Widget";
import PageTitle from "../../components/PageTitle/PageTitle";
import { withStyles, makeStyles } from '@material-ui/core/styles';
const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#0f3b62ad",
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);
const LESSON_IMAGE_BASE =
    process.env.REACT_APP_AZURE_BLOB_ACCOUNT_URL
        ? `${process.env.REACT_APP_AZURE_BLOB_ACCOUNT_URL.replace(/\/+$/, '')}/lesson`
        : 'https://artistimages.blob.core.windows.net/lesson';

const resolveLessonImageUrls = (images) => {
    const list = Array.isArray(images) ? images : images ? [images] : [];
    return list
        .map((item) => {
            const raw = String(item || '').trim();
            if (!raw) return '';
            if (/^https?:\/\//i.test(raw)) return raw;
            const blobName = raw.replace(/^\/+/, '').split('/').pop();
            return blobName ? `${LESSON_IMAGE_BASE}/${encodeURIComponent(blobName)}` : '';
        })
        .filter(Boolean);
};

const resolveSchoolId = (userDetails) =>
    userDetails?.schooleId?._id
    || userDetails?.schooleId
    || userDetails?.schoolId?._id
    || userDetails?.schoolId
    || '';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 200,
    },
    filterRow: {
        marginBottom: theme.spacing(2),
        padding: theme.spacing(2),
    },
}));
export default function Lesson() {
    const tableHeaders = [
        'class',
        'Section',
        'Subject',
        'Lesson',
        'objectives',
        'materialRequired',
        'stepsAndProcedures',
        'Control Of Error',
        'Point Of Interest',
        'Edit',
        'Delete',
    ];
    const [images, setImages] = useState([]);
    const [imageslist, setImagesList] = useState([]);
    const [message, setMessage] = useState("");
    const classes = useStyles();
    const [studentList, setStudentList] = useState([]);
    const [addClassList, setAddClassList] = useState([]);
    const [sectionList, setSectionList] = useState([]);
    const [filterSectionList, setFilterSectionList] = useState([]);

    const [lessonList, setLessonList] = useState([]);
    const [dueDate, setFormDueDate] = useState("");
    const [age, setAge] = React.useState('');
    var [error, setError] = useState(null);
    var [uploadError, setUploadError] = useState({ isShowError: false, successCount: 0, error: [], message: "" });
    const [open, setOpen] = React.useState(false);
    const [open1, setOpen1] = React.useState(false);
    const [pg, setpg] = React.useState(0);
    const [rpg, setrpg] = React.useState(100);
    const current = new Date();
    var [classId, setClassId] = useState("");
    const date = `${current.getFullYear()}-0${current.getMonth() + 1}-${current.getDate()}`;
    var [dateValue, setDateValue] = useState(date);
    const [lessonId, setLessonId] = useState('');
    const [viewDialog, setViewDialog] = useState({
        open: false,
        title: '',
        items: [],
    });
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [pendingDelete, setPendingDelete] = useState(null);
    const [filterClassId, setFilterClassId] = useState('');
    const [filterSectionId, setFilterSectionId] = useState('');
    const [filterSubject, setFilterSubject] = useState('');
    const [filterLessonId, setFilterLessonId] = useState('');
    const [lessonOptions, setLessonOptions] = useState([]);
    const pendingFormResetRef = useRef(false);
    const [year, month, day] = date.split("-");
    //     const [images, setImages] = useState([]);
    //  const [imageslists, setImagesLists] = useState([]);
    const [lesson, setLesson] = useState({
        lesson: '',
        subject: '',
        images: [],
        objectives: [],
        video: '',
        classId: '',
        sectionId: '',
        materialRequired: [],
        stepsAndProcedures: [],
        controlOfError: [],
        pointOfInterest: [],

    });

    const sanitizeList = (items) =>
        (Array.isArray(items) ? items : [])
            .map((s) => String(s || '').trim())
            .filter(Boolean);

    const requiredListField = (label) =>
        Yup.array().test(
            'has-non-empty-items',
            `At least one ${label} is required`,
            (value) => sanitizeList(value).length > 0,
        );

    const optionalListField = () => Yup.array().of(Yup.string());

    const validationSchema = Yup.object().shape({
        lesson: Yup.string().required('lesson is required'),
        images: Yup.array(),
        objectives: optionalListField(),
        video: Yup.string(),
        remarks: Yup.string(),
        classId: Yup.string().required('Class Name is required'),
        subject: Yup.string().trim().required('Subject is required'),
        materialRequired: optionalListField(),
        stepsAndProcedures: requiredListField('step in Steps and Procedures'),
        controlOfError: optionalListField(),
        pointOfInterest: requiredListField('Point of Interest'),
    });

    const getListFieldError = (errors, fieldName) => {
        const err = errors?.[fieldName];
        if (!err) return '';
        if (typeof err === 'string') return err;
        if (Array.isArray(err)) {
            const first = err.find((item) => typeof item === 'string' && item);
            return first || '';
        }
        return '';
    };
    const verifyeetnt = () => {
        console.log(formik)
    }
    const handleOpen = (status) => {


        if (status) {
            pendingFormResetRef.current = true;
            setLesson({
                lesson: '',
                subject: '',
                images: [],
                objectives: [],
                video: '',
                classId: '',
                sectionId: '',
                remarks: '',
                materialRequired: [],
                stepsAndProcedures: [],
                pointOfInterest: [],
                controlOfError: [],
            });
        }

        setOpen(true);
    };
    const handleChangePage = (event, newpage) => {
        setpg(newpage);
    }
    const handleChangeRowsPerPage = (event) => {
        setrpg(parseInt(event.target.value, 10));
        setpg(0);
    }

    useEffect(() => {
        getAddClassList();
        return () => {
            setLessonList([]);
            setStudentList([]);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Revoke any local blob preview URLs (not the persisted https:// image URLs)
    // whenever the selected image list changes, to avoid leaking memory.
    useEffect(() => {
        return () => {
            imageslist.forEach((url) => {
                if (typeof url === 'string' && url.startsWith('blob:')) {
                    URL.revokeObjectURL(url);
                }
            });
        };
    }, [imageslist]);

    const buildFilterBody = (forLessonDropdown = false) => {
        const userDetails = JSON.parse(localStorage.getItem('userDetail') || '{}');
        const body = {};
        const schooleId = resolveSchoolId(userDetails);
        if (schooleId) body.schooleId = schooleId;
        if (filterClassId) body.classId = filterClassId;
        if (filterSectionId) body.sectionId = filterSectionId;
        if (filterSubject.trim()) body.subject = filterSubject.trim();
        if (!forLessonDropdown && filterLessonId) body.lessonId = filterLessonId;
        return body;
    };

    const fetchLessonOptions = () => {
        LessonService.findLessonList(buildFilterBody(true))
            .then((res) => {
                setLessonOptions(Array.isArray(res) ? res : []);
            })
            .catch((err) => {
                setLessonOptions([]);
                setError(err.message);
            });
    };

    useEffect(() => {
        fetchLessonOptions();
        getLessonList();
        setpg(0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterClassId, filterSectionId, filterSubject, filterLessonId]);

    const clearFilters = () => {
        setFilterClassId('');
        setFilterSectionId('');
        setFilterSubject('');
        setFilterLessonId('');
        setpg(0);
    };
    const dateAndTime = (date) => {

        const systemDate = new Date(date);
        const formattedDateTime = systemDate.toLocaleString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            // hour: 'numeric',
            // minute: 'numeric',
            // second: 'numeric',
            // hour12: true,

        });
        return formattedDateTime;
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormDueDate(value);
    };
    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files || []);
        setImages(selectedFiles);
    };

    const handleUpload = async (e) => {
        e.preventDefault();

        const files = Array.isArray(images) ? images : [];
        if (!files.length) {
            setMessage("Please select images first.");
            return;
        }

        try {
            setMessage("Uploading images…");
            const uploadedUrls = [];

            for (const file of files) {
                const formData = new FormData();
                formData.append("image", file);
                formData.append("imageName", file.name);
                // eslint-disable-next-line no-await-in-loop
                const res = await IconMasterService.uploadImage(formData);
                const url = res?.url || res?.data?.url || "";
                if (!url) {
                    throw new Error("Upload succeeded but no image URL returned.");
                }
                uploadedUrls.push(url);
            }

            setImagesList((prev) => [...prev, ...uploadedUrls]);
            formik.setFieldValue("images", [...(formik.values.images || []), ...uploadedUrls]);
            setImages([]);
            setMessage("");
            alert("Images uploaded successfully");
        } catch (error) {
            console.error("Error uploading images:", error);
            const errMsg =
                error?.response?.data?.message ||
                error.message ||
                "An error occurred while uploading the images.";
            setMessage(errMsg);
            alert(errMsg);
        }
    };
    const getLessonList = () => {
        LessonService.findLessonList(buildFilterBody(false))
            .then((res) => {
                const rows = Array.isArray(res) ? res : [];
                setLessonList(rows);
                setFilterLessonId((prev) => {
                    if (!prev) return prev;
                    return rows.some((row) => String(row._id) === String(prev)) ? prev : '';
                });
            })
            .catch((err) => {
                setLessonList([]);
                setError(err.message);
            });
    };
    //   const getLessonList = () => {

    //     LessonService.getAllLesson()
    //       .then((res) => {

    //         const formattedEvents = res.map((event) => {
    //           const formattedDate = event.date ? formatDate(event.date) : "";
    //           return { ...event, date: formattedDate };
    //         });

    //         setEventList(formattedEvents);
    //       })
    //       .catch((err) => {
    //         setError(err.message);
    //       });
    //   };
    const formatDate = (date) => {
        const [year, month, day] = date.split("-"); // Split the date string (YY-MM-DD)
        return `${day}-${month}-${year.slice(2)}`; // Return in DD-MM-YY format
    };

    const handleOpen1 = () => {
        setOpen1(true);
    };

    const handleClose = () => {
        setOpen(false);
        setImagesList([]);
        setImages([]);
    };
    const removeImage = async (index) => {
        const updatedList = [...imageslist];
        const url = updatedList[index];
        updatedList.splice(index, 1);
        setImagesList(updatedList);
        if (formik?.setFieldValue) {
            formik.setFieldValue('images', updatedList);
        }
        if (url && /^https?:\/\//i.test(String(url))) {
            try {
                await IconMasterService.deleteAzureImage({ imageURL: url });
            } catch (err) {
                console.error('Failed to delete image from Azure:', err);
            }
        }
    };
    const handleClose1 = () => {
        setOpen1(false);
    };
    const getAddClassList = () => {
        const userDetails = JSON.parse(localStorage.getItem('userDetail') || '{}');
        const schooleId = resolveSchoolId(userDetails);
        const role = userDetails?.role;

        if (!schooleId && role !== 'SUPERADMIN') {
            setAddClassList([]);
            return;
        }

        AddClassService.getAllAddClass(schooleId, role, true)
            .then((res) => {
                let rows = Array.isArray(res) ? res : res?.data || [];
                if (role === 'TEACHER' && userDetails.classId) {
                    const teacherClassId = String(userDetails.classId?._id || userDetails.classId);
                    rows = rows.filter((row) => String(row._id) === teacherClassId);
                }
                setAddClassList(rows);
            })
            .catch(() => {
                setAddClassList([]);
            });
    };

    const getSubjectName = (lessonRow) => {
        if (lessonRow?.subject) return lessonRow.subject;
        if (!lessonRow?.subjectId) return '';
        if (typeof lessonRow.subjectId === 'object') {
            return lessonRow.subjectId.subject || '';
        }
        return '';
    };

    const getSectionName = (lessonRow) => {
        if (!lessonRow?.sectionId) return 'All Sections';
        if (typeof lessonRow.sectionId === 'object') {
            return lessonRow.sectionId.sectionName || 'All Sections';
        }
        return 'All Sections';
    };

    const loadSectionList = (classId, { forFilter = false } = {}) => {
        if (!classId) {
            if (forFilter) setFilterSectionList([]);
            else setSectionList([]);
            return;
        }
        const userDetails = JSON.parse(localStorage.getItem('userDetail') || '{}');
        const schooleId = resolveSchoolId(userDetails);
        SectionService.findSectionList({ schooleId, classId, status: true })
            .then((res) => {
                const rows = Array.isArray(res) ? res : [];
                if (forFilter) setFilterSectionList(rows);
                else setSectionList(rows);
            })
            .catch(() => {
                if (forFilter) setFilterSectionList([]);
                else setSectionList([]);
            });
    };

    useEffect(() => {
        loadSectionList(filterClassId, { forFilter: true });
        setFilterSectionId('');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filterClassId]);

    const openViewDialog = (title, items) => {
        const list = Array.isArray(items)
            ? items.map((item) => String(item || '').trim()).filter(Boolean)
            : [];
        setViewDialog({ open: true, title, items: list });
    };

    const closeViewDialog = () => {
        setViewDialog({ open: false, title: '', items: [] });
    };

    const editLesson = (lessonRow) => {
        const payload = { ...lessonRow };
        payload.classId = lessonRow.classId ? lessonRow.classId._id : '';
        payload.sectionId = lessonRow.sectionId
            ? (typeof lessonRow.sectionId === 'object' ? lessonRow.sectionId._id : lessonRow.sectionId)
            : '';
        payload.subject = lessonRow.subject || getSubjectName(lessonRow);
        delete payload.subjectId;
        const existingImages = resolveLessonImageUrls(lessonRow.images);
        payload.images = existingImages;
        setImagesList(existingImages);
        setImages([]);
        setLesson(payload);
        handleOpen(false);
    }

    const deleteLesson = (lessonRow) => {
        if (!lessonRow) return;
        setPendingDelete(lessonRow);
        setDeleteConfirmOpen(true);
    };

    const confirmDeleteLesson = async () => {
        const row = pendingDelete;
        setDeleteConfirmOpen(false);
        setPendingDelete(null);
        if (!row) return;
        try {
            await LessonService.deleteLesson(row);
            getLessonList();
        } catch (err) {
            alert(err?.response?.data?.message || err?.message || 'Failed to delete lesson.');
        }
    };


    const formik = useFormik({
        initialValues: lesson,
        enableReinitialize: true,
        validationSchema,
        validateOnBlur: true,
        validateOnChange: false,
        onSubmit: (values, { resetForm }) => {
            const userDetails = JSON.parse(localStorage.getItem('userDetail') || '{}');
            const payload = {
                ...values,
                subject: String(values.subject || '').trim(),
                schooleId: resolveSchoolId(userDetails),
                images: imageslist,
                objectives: sanitizeList(values.objectives),
                materialRequired: sanitizeList(values.materialRequired),
                controlOfError: sanitizeList(values.controlOfError),
                stepsAndProcedures: sanitizeList(values.stepsAndProcedures),
                pointOfInterest: sanitizeList(values.pointOfInterest),
            };
            if (!payload.sectionId) {
                payload.sectionId = null;
            }
            delete payload.subjectId;
            if (lesson._id) {
                LessonService.upadeLesson(payload).then((res) => {
                    handleClose();
                    getLessonList();
                    resetForm()
                    alert("Lesson Updated Successfully.");
                }).catch((err) => {
                });
            }
            else {
                payload.images = imageslist;
                LessonService.creteLesson(payload).then((res) => {
                    getLessonList();
                    resetForm();
                    handleClose();
                    setImagesList([]);
                    alert(" Lesson Added Successfully.");
                    // props.history.push('/app/vendor');
                })
                    .catch((err) => {
                        alert(err.response.data.message)
                    })
            }

        },
    });

    useEffect(() => {
        if (!open || !pendingFormResetRef.current) return;
        formik.resetForm({ values: lesson });
        pendingFormResetRef.current = false;
    }, [open, lesson]);

    useEffect(() => {
        loadSectionList(formik.values.classId);
        if (!formik.values.classId) {
            formik.setFieldValue('sectionId', '');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.classId]);

    const showFieldErrors = (fieldName) => {
        if (formik.submitCount > 0) return true;
        return Boolean(formik.touched[fieldName]);
    };

    const showListFieldErrors = () => formik.submitCount > 0;

    const test = () => {
        console.log(formik)
    };

    const onSubmit = data => {
        const userDetails = JSON.parse(localStorage.getItem("userDetail"));
        const keys = {
            "schooleId": userDetails.schooleId, "studentList": studentList, "teacherId": userDetails._id,
            "date": dateValue
        }
        LessonService.creteLesson(keys).then((res) => {

            setDateValue("");
            setStudentList([]);
            alert(" Event Successfully.");
        }).catch((err) => {

            alert(err.response.data.message);
        });
    };
    return (

        <>
            <PageTitle title="Lessons" button={<Button

                variant="contained" onClick={() => handleOpen(true)}
                size="medium"
                color="secondary" style={{ backgroundColor: 'rgb(15 59 98)' }}> Add Lesson
            </Button>} />
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Widget title="" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
                        <Box className={classes.filterRow}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} sm={6} md={3}>
                                    <FormControl fullWidth variant="outlined" size="small">
                                        <InputLabel>Filter by Class</InputLabel>
                                        <Select
                                            label="Filter by Class"
                                            value={filterClassId}
                                            onChange={(e) => {
                                                setFilterClassId(e.target.value);
                                                setFilterSectionId('');
                                                setFilterLessonId('');
                                            }}
                                        >
                                            <MenuItem value="">
                                                <em>All Classes</em>
                                            </MenuItem>
                                            {addClassList.map(({ _id, className }) => (
                                                <MenuItem key={_id} value={_id}>
                                                    {className}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <FormControl fullWidth variant="outlined" size="small" disabled={!filterClassId}>
                                        <InputLabel>Filter by Section</InputLabel>
                                        <Select
                                            label="Filter by Section"
                                            value={filterSectionId}
                                            onChange={(e) => {
                                                setFilterSectionId(e.target.value);
                                                setFilterLessonId('');
                                            }}
                                        >
                                            <MenuItem value="">
                                                <em>All Sections</em>
                                            </MenuItem>
                                            {filterSectionList.map(({ _id, sectionName }) => (
                                                <MenuItem key={_id} value={_id}>
                                                    {sectionName}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        size="small"
                                        label="Filter by Subject"
                                        value={filterSubject}
                                        onChange={(e) => {
                                            setFilterSubject(e.target.value);
                                            setFilterLessonId('');
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <FormControl fullWidth variant="outlined" size="small">
                                        <InputLabel>Filter by Lesson</InputLabel>
                                        <Select
                                            label="Filter by Lesson"
                                            value={filterLessonId}
                                            onChange={(e) => {
                                                setFilterLessonId(e.target.value);
                                                setpg(0);
                                            }}
                                        >
                                            <MenuItem value="">
                                                <em>All Lessons</em>
                                            </MenuItem>
                                            {lessonOptions.map((row) => (
                                                <MenuItem key={row._id} value={row._id}>
                                                    {row.lesson}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={3}>
                                    <Button
                                        variant="outlined"
                                        color="secondary"
                                        onClick={clearFilters}
                                        disabled={!filterClassId && !filterSectionId && !filterSubject.trim() && !filterLessonId}
                                    >
                                        Clear Filters
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                        <TableContainer component={Paper} style={{ maxHeight: 500 }}>
                        
                        <Table stickyHeader className="mb-0">
                            <TableHead >
                                <TableRow>
                                    {tableHeaders.map(key => (
                                        <StyledTableCell key={key}>{key}</StyledTableCell>
                                    ))}
                                </TableRow>

                            </TableHead>
                            <TableBody>
                                {/* {calenderAssignmentList.slice(pg * rpg, pg * rpg + rpg).map((calenderassignment) => ( */}

                                {lessonList.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={tableHeaders.length} align="center">
                                            No lessons found.
                                        </TableCell>
                                    </TableRow>
                                ) : null}
                                {lessonList.slice(pg * rpg, pg * rpg + rpg).map((lesson) => (
                                    <TableRow key={lesson._id}>

                                        <TableCell className="pl-3 fw-normal">{lesson.classId ? lesson.classId.className : ''}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{getSectionName(lesson)}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{getSubjectName(lesson)}</TableCell>
                                        <TableCell className="pl-3 fw-normal">{lesson.lesson}</TableCell>
                                        <TableCell align="center">
                                            <VisibilityIcon
                                                style={{ cursor: 'pointer', color: 'rgb(15 59 98)' }}
                                                onClick={() => openViewDialog('Objectives', lesson.objectives)}
                                                title="View objectives"
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            <VisibilityIcon
                                                style={{ cursor: 'pointer', color: 'rgb(15 59 98)' }}
                                                onClick={() => openViewDialog('Material Required', lesson.materialRequired)}
                                                title="View material required"
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            <VisibilityIcon
                                                style={{ cursor: 'pointer', color: 'rgb(15 59 98)' }}
                                                onClick={() => openViewDialog('Steps And Procedures', lesson.stepsAndProcedures)}
                                                title="View steps and procedures"
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            <VisibilityIcon
                                                style={{ cursor: 'pointer', color: 'rgb(15 59 98)' }}
                                                onClick={() => openViewDialog('Control Of Error', lesson.controlOfError)}
                                                title="View control of error"
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            <VisibilityIcon
                                                style={{ cursor: 'pointer', color: 'rgb(15 59 98)' }}
                                                onClick={() => openViewDialog('Point Of Interest', lesson.pointOfInterest)}
                                                title="View point of interest"
                                            />
                                        </TableCell>

                                        <TableCell>
                                            <EditIcon style={{ cursor: 'pointer' }} onClick={() => editLesson(lesson)} >
                                            </EditIcon >
                                        </TableCell>
                                        <TableCell>
                                            <DeleteIcon style={{ cursor: 'pointer' }} onClick={() => deleteLesson(lesson)} />
                                        </TableCell>
                                    </TableRow>
                                ))}

                            </TableBody>
                        </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[1000, 10000, 1000000]}
                            count={lessonList.length}
                            page={pg}
                            onPageChange={handleChangePage}
                            rowsPerPage={rpg}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Widget>
                </Grid>
            </Grid>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Add Lesson</DialogTitle>


                <DialogContent style={{ width: 600 }}>
                    <FormControl className={classes.formControl} fullWidth="true"
                    >
                        <InputLabel id="demo-simple-select-label">Select Class</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            name="classId"
                            label="selectClass"

                            value={formik.values.classId}
                            onChange={(e) => {
                                formik.handleChange(e);
                                formik.setFieldValue('sectionId', '');
                            }}


                            error={formik.touched.classId && Boolean(formik.errors.classId)}
                            helperText={formik.touched.classId && formik.errors.classId}
                        >
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>

                            {addClassList.map(({ _id, className }) => (
                                <MenuItem key={_id} value={_id}>{className}

                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl className={classes.formControl} fullWidth="true" style={{ marginTop: 16 }}>
                        <InputLabel id="lesson-section-label">Select Section</InputLabel>
                        <Select
                            labelId="lesson-section-label"
                            id="lesson-section"
                            name="sectionId"
                            label="Select Section"
                            value={formik.values.sectionId}
                            onChange={formik.handleChange}
                            disabled={!formik.values.classId}
                        >
                            <MenuItem value="">
                                <em>All Sections</em>
                            </MenuItem>
                            {sectionList.map(({ _id, sectionName }) => (
                                <MenuItem key={_id} value={_id}>{sectionName}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <TextField
                        InputProps={{ style: { width: 550 } }}
                        margin="dense"
                        id="subject"
                        name="subject"
                        label="Subject *"
                        type="text"
                        variant="standard"
                        value={formik.values.subject}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={showFieldErrors('subject') && Boolean(formik.errors.subject)}
                        helperText={showFieldErrors('subject') && formik.errors.subject}
                    />
                    <TextField InputProps={{ style: { width: 550 } }}
                        margin="dense"
                        id="lesson"
                        name="lesson"
                        label="Lesson"
                        type="text"
                        variant="standard"
                        value={formik.values.lesson}
                        onChange={formik.handleChange}
                        error={formik.touched.lesson && Boolean(formik.errors.lesson)}
                        helperText={formik.touched.lesson && formik.errors.lesson}
                    />
                    {/* <TextField InputProps={{ style: { width: 550 } }}
                        margin="dense"
                        id="objectives"
                        name="objectives"
                        label="Objectives"
                        type="text"
                        variant="standard"
                        value={formik.values.objectives}
                        onChange={formik.handleChange}
                        error={formik.touched.objectives && Boolean(formik.errors.objectives)}
                        helperText={formik.touched.objectives && formik.errors.objectives}
                    /> */}
                    <Grid container spacing={4}>
                        <Grid item lg={6} xs={12}>
                            <DynamicListInput
                                label="Objectives"
                                name="objectives"
                                values={formik.values.objectives}
                                onChange={(val) => formik.setFieldValue("objectives", val)}
                            />
                        </Grid>
                        <Grid item lg={6} xs={12}>

                            <DynamicListInput
                                label="Material Required"
                                name="materialRequired"
                                values={formik.values.materialRequired}
                                onChange={(val) => formik.setFieldValue("materialRequired", val)}
                            />
                        </Grid>
                        <Grid item lg={6} xs={12}>
                            <DynamicListInput
                                label="Steps and Procedures *"
                                values={formik.values.stepsAndProcedures}
                                error={getListFieldError(formik.errors, 'stepsAndProcedures')}
                                showErrors={showListFieldErrors()}
                                onChange={(val) => formik.setFieldValue('stepsAndProcedures', val)}
                                onBlur={() => formik.setFieldTouched('stepsAndProcedures', true)}
                            />
                        </Grid>
                        <Grid item lg={6} xs={12}>

                            <DynamicListInput
                                label="Control of Error"
                                name="controlOfError"
                                values={formik.values.controlOfError}
                                onChange={(val) => formik.setFieldValue("controlOfError", val)}
                            />
                        </Grid>
                    </Grid>

                    <DynamicListInput
                        label="Point of Interest *"
                        values={formik.values.pointOfInterest}
                        error={getListFieldError(formik.errors, 'pointOfInterest')}
                        showErrors={showListFieldErrors()}
                        onChange={(val) => formik.setFieldValue('pointOfInterest', val)}
                        onBlur={() => formik.setFieldTouched('pointOfInterest', true)}
                    />
                    {/* <TextField InputProps={{ style: { width: 550 } }}
                        margin="dense"
                        id="materialRequired"
                        name="materialRequired"
                        label="Material Required"
                        type="text"
                        variant="standard"
                        value={formik.values.materialRequired}
                        onChange={formik.handleChange}
                        error={formik.touched.materialRequired && Boolean(formik.errors.materialRequired)}
                        helperText={formik.touched.materialRequired && formik.errors.materialRequired}
                    /> */}
                    {/* <TextField InputProps={{ style: { width: 550 } }}
                        margin="dense"
                        id="stepsAndProcedures"
                        name="stepsAndProcedures"
                        label="Steps And Procedures"
                        type="text"
                        variant="standard"
                        value={formik.values.stepsAndProcedures}
                        onChange={formik.handleChange}
                        error={formik.touched.stepsAndProcedures && Boolean(formik.errors.stepsAndProcedures)}
                        helperText={formik.touched.stepsAndProcedures && formik.errors.stepsAndProcedures}
                    /> */}

                    <TextField fullWidth
                        margin="dense"
                        id="video"
                        name="video"
                        label="Video Link"
                        type="text"
                        variant="standard"
                        value={formik.values.video}
                        onChange={formik.handleChange}
                        error={formik.touched.video && Boolean(formik.errors.video)}
                        helperText={formik.touched.video && formik.errors.video}
                    />
                    <TextField fullWidth
                        margin="dense"
                        id="remarks"
                        name="remarks"
                        label="Remarks"
                        type="text"
                        variant="standard"
                        value={formik.values.remarks}
                        onChange={formik.handleChange}
                        error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                        helperText={formik.touched.remarks && formik.errors.remarks}
                    />
                    <input fullWidth
                        type="file"
                        accept="image/*"
                        // Enable multiple file selection
                        onChange={handleFileChange}
                    />
                    <Button style={{ backgroundColor: 'rgb(21 61 96)', color: 'white', border: 'none' }} onClick={handleUpload}>Upload</Button>

                    {/* {imageslist.length > 0 && (
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                            {imageslist.map((url, index) => (
                                <img
                                    key={index}
                                    src={url}
                                    alt={`Uploaded ${index + 1}`}
                                    style={{ width: "100px", height: "100px", objectFit: "cover" }}
                                />
                            ))}
                        </div>
                    )} */}
                    {imageslist.length > 0 && (
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: 10 }}>
                            {imageslist.map((url, index) => (
                                <div key={index} style={{ position: 'relative' }}>
                                    <img
                                        src={url}
                                        alt={`Preview ${index + 1}`}
                                        style={{ width: 100, height: 100, objectFit: "cover", borderRadius: 4 }}
                                    />
                                    <Button
                                        size="small"
                                        style={{ position: 'absolute', top: -5, right: -5, minWidth: 20, padding: 0 }}
                                        onClick={() => removeImage(index)}
                                    >
                                        ❌
                                    </Button>
                                </div>
                            ))}
                        </div>
                    )}

                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button
                        type="submit" onClick={formik.handleSubmit}
                    // onClick={test}
                    >Add</Button>
                </DialogActions>

            </Dialog>

            <Dialog open={viewDialog.open} onClose={closeViewDialog} maxWidth="sm" fullWidth>
                <DialogTitle>{viewDialog.title}</DialogTitle>
                <DialogContent dividers>
                    {viewDialog.items.length > 0 ? (
                        <ol style={{ margin: 0, paddingLeft: 20 }}>
                            {viewDialog.items.map((item, index) => (
                                <li key={`${viewDialog.title}-${index}`} style={{ marginBottom: 8 }}>
                                    <Typography variant="body2">{item}</Typography>
                                </li>
                            ))}
                        </ol>
                    ) : (
                        <Typography variant="body2" color="textSecondary">
                            No data available.
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeViewDialog} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={deleteConfirmOpen}
                onClose={() => {
                    setDeleteConfirmOpen(false);
                    setPendingDelete(null);
                }}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>Delete Lesson</DialogTitle>
                <DialogContent dividers>
                    <Typography variant="body2">
                        Are you sure you want to delete{' '}
                        <b>
                            &quot;
                            {pendingDelete?.lesson
                                ? String(pendingDelete.lesson)
                                : 'this lesson'}
                            &quot;
                        </b>
                        ?
                        <br />
                        <br />
                        This action cannot be undone. All associated data will be permanently removed.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            setDeleteConfirmOpen(false);
                            setPendingDelete(null);
                        }}
                        style={{ backgroundColor: '#f3e5e5', color: '#0f3b62' }}
                        variant="contained"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={confirmDeleteLesson}
                        style={{ backgroundColor: 'rgb(15 59 98)', color: 'white' }}
                        variant="contained"
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}


const DynamicListInput = ({
    label,
    values,
    onChange,
    onBlur,
    error,
    showErrors = false,
}) => {
    useEffect(() => {
        if (!values || values.length === 0) {
            onChange(['']);
        }
    }, [values, onChange]);

    const handleAdd = () => onChange([...values, '']);

    const handleRemove = (index) => {
        const newList = [...values];
        newList.splice(index, 1);
        onChange(newList.length ? newList : ['']);
    };

    const handleInputChange = (e, index) => {
        const newList = [...values];
        newList[index] = e.target.value;
        onChange(newList);
    };

    const showError = showErrors && Boolean(error);

    return (
        <div style={{ marginTop: 10 }} onBlur={onBlur}>
            <Typography variant="body2" style={{ fontWeight: 600, color: 'rgba(0, 0, 0, 0.87)' }}>
                {label}
            </Typography>
            {values.map((val, index) => (
                <div key={index} style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 5 }}>
                    <TextField
                        fullWidth
                        value={val}
                        onChange={(e) => handleInputChange(e, index)}
                        onBlur={onBlur}
                    />
                    {values.length > 1 && index !== 0 ? (
                        <DeleteIcon onClick={() => handleRemove(index)} style={{ cursor: 'pointer' }} />
                    ) : null}
                </div>
            ))}
            <AddIcon style={{ cursor: 'pointer' }} onClick={handleAdd} />
            {showError ? (
                <FormHelperText error style={{ marginLeft: 0 }}>
                    {error}
                </FormHelperText>
            ) : null}
        </div>
    );
};
